import React from 'react';
import SolutionSuccessContainer from 'containers/SolutionSuccessContainer/SolutionSuccessContainer';

export default function SolutionSuccessPage() {
    return (
        <SolutionSuccessContainer />
    )
}
